import { minBreakpoints, primarySemiBoldFont, responsiveFontSize, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, smallElevation } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
import { CATEGORY_CARD_MEDIUM_IMAGE_SIZE, CATEGORY_CARD_SMALL_IMAGE_SIZE } from "../constants";
var spacing = theme.spacing,
  text = theme.text;
var categoryTitleSizes = {
  XXS: text.BODY.SM,
  M: text.BODY.MD
};
export var link = /*#__PURE__*/css(["display:grid;border-radius:", ";text-decoration:none;width:", ";", " ", ""], pxToRem(10), pxToRem(CATEGORY_CARD_SMALL_IMAGE_SIZE), mediaQuery({
  min: minBreakpoints.M
}, css(["width:", ";"], pxToRem(CATEGORY_CARD_MEDIUM_IMAGE_SIZE))), mediaQuery({
  min: minBreakpoints.L
}, css(["&:hover{", ";}"], smallElevation)));
export var image = /*#__PURE__*/css(["border-top-left-radius:", ";border-top-right-radius:", ";object-fit:cover;height:", ";overflow:hidden;display:block;width:100%;", ""], pxToRem(10), pxToRem(10), pxToRem(CATEGORY_CARD_SMALL_IMAGE_SIZE), mediaQuery({
  min: minBreakpoints.M
}, css(["height:", ";"], pxToRem(CATEGORY_CARD_MEDIUM_IMAGE_SIZE))));
export var categoryTitle = /*#__PURE__*/css(["background-color:var(--backgroundColor,var(--neutral-black-10));padding:", ";margin:0;height:", ";color:var(--neutral-black-base);", ";", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";"], pxToRem(spacing.md), pxToRem(88), primarySemiBoldFont, responsiveFontSize(categoryTitleSizes), pxToRem(10), pxToRem(10));